import { Euro, Globe, Users, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
export const MarketStats = () => {
  const {
    t
  } = useTranslation("landing");
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-16 bg-gradient-to-r from-primary/90 via-purple-600/90 to-primary/90 text-white">
      <motion.div className="container mx-auto px-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true
    }}>
        <motion.div className="text-center mb-12" variants={itemVariants}>
          
          <h2 className="text-2xl md:text-4xl font-bold mb-4">{t("marketStats.title")}</h2>
          <p className="text-base mx-auto max-w-3xl opacity-90">
            {t("marketStats.subtitle")}
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-4 gap-5">
          <motion.div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center shadow-lg border border-white/20 hover:bg-white/15 transition-colors duration-300" variants={itemVariants} whileHover={{
          y: -8,
          scale: 1.03,
          transition: {
            duration: 0.3
          }
        }}>
            <div className="bg-white/20 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center shadow-md">
              <Globe className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-bold mb-2">{t("marketStats.percent")}</h3>
            <p className="opacity-90 leading-relaxed text-sm">{t("marketStats.percentDesc")}</p>
            <div className="mt-4 h-1 w-12 bg-white/30 mx-auto rounded-full"></div>
          </motion.div>
          
          <motion.div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center shadow-lg border border-white/20 hover:bg-white/15 transition-colors duration-300" variants={itemVariants} whileHover={{
          y: -8,
          scale: 1.03,
          transition: {
            duration: 0.3
          }
        }}>
            <div className="bg-white/20 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center shadow-md">
              <Euro className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-bold mb-2">{t("marketStats.trillion")}</h3>
            <p className="opacity-90 leading-relaxed text-sm">{t("marketStats.marketSize")}</p>
            <div className="mt-4 h-1 w-12 bg-white/30 mx-auto rounded-full"></div>
          </motion.div>
          
          <motion.div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center shadow-lg border border-white/20 hover:bg-white/15 transition-colors duration-300" variants={itemVariants} whileHover={{
          y: -8,
          scale: 1.03,
          transition: {
            duration: 0.3
          }
        }}>
            <div className="bg-white/20 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center shadow-md">
              <Users className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-bold mb-2">{t("marketStats.smeWeight")}</h3>
            <p className="opacity-90 leading-relaxed text-sm">{t("marketStats.smeWeightDesc")}</p>
            <div className="mt-4 h-1 w-12 bg-white/30 mx-auto rounded-full"></div>
          </motion.div>
          
          <motion.div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center shadow-lg border border-white/20 hover:bg-white/15 transition-colors duration-300" variants={itemVariants} whileHover={{
          y: -8,
          scale: 1.03,
          transition: {
            duration: 0.3
          }
        }}>
            <div className="bg-white/20 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center shadow-md">
              <TrendingUp className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-bold mb-2">{t("marketStats.barriers")}</h3>
              <p className="opacity-90 leading-relaxed text-sm">{t("marketStats.barriersDesc")}</p>
              <div className="mt-4 h-1 w-12 bg-white/30 mx-auto rounded-full"></div>
          </motion.div>
        </div>
        
        
      </motion.div>
    </section>;
};